import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let CheckboxComponent = class extends Mixins(MagicConfigMixin) {
  handleChange(event) {
    if (!(event.target instanceof HTMLInputElement)) {
      return;
    }
    const isChecked = event.target.checked;
    if (this.radio && isChecked === false) {
      event.target.checked = true;
      event.preventDefault();
      return;
    }
    this.onChange(isChecked);
  }
  onChange(isChecked) {
    return isChecked;
  }
};
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "value", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "bold", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "inline", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "noLabel", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "noMargin", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "hasError", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "radio", 2);
__decorateClass([
  Prop(Boolean)
], CheckboxComponent.prototype, "indeterminate", 2);
__decorateClass([
  Emit("change")
], CheckboxComponent.prototype, "onChange", 1);
CheckboxComponent = __decorateClass([
  Component({
    name: "ui-checkbox"
  })
], CheckboxComponent);

export default CheckboxComponent;
